<template>
  <div id="app" class="d-flex flex-column h-100">
    <app-header></app-header>
    <main role="main" class="flex-shrink-0 flex-grow-1">
      <router-view />
    </main>
    <footer class="footer mt-auto py-3 bg-light">
      <div class="container-fluid d-flex flex-wrap">
        <span class="text-muted mr-auto">Parking Społeczny Kopcińskiego</span>
        <span class="text-muted">
          <router-link :to="{name: 'cookies-policy'}">Polityka Cookies</router-link>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from '@/app/layout/header';

export default {
  components: { AppHeader },
};
</script>
